<template>
  <button-tooltip
    :tooltip="tooltip"
    :label="label"
    size="is-small"
    type="is-light"
    multilined
    :icon-left="icon"
    @click="copyToClipboard"
  />
</template>

<script>
import ButtonTooltip from "@/components/ui/ButtonTooltip.vue";

export default {
  name: "CopyToClipboard",

  components: {
    ButtonTooltip,
  },

  props: {
    value: {
      type: String,
      required: true,
    },
    successMessage: {
      type: String,
      default: "Copied to clipboard!",
    },
    label: {
      type: String,
      default: "Copy",
    },
    icon: {
      type: String,
      default: "clipboard",
    },
    tooltip: {
      type: String,
      default: "Copy to clipboard",
    },
  },

  methods: {
    copyToClipboard() {
      navigator.clipboard.writeText(this.value).then(() => {
        this.$buefy.toast.open(this.successMessage);
      });
    },
  },
};
</script>
